import Footer from "../component/Footer";
import Header from "../component/Header";

const Layout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">

      {/* Fixed Header */}
      <div className="fixed top-0 left-0 right-0 z-50">
        <Header />
      </div>

      {/* Scrollable Content */}
      <main className="flex-grow overflow-y-auto pt-[80px] pb-[70px]">
        {children}
      </main>

      {/* Fixed Footer */}
      <div className="fixed bottom-0 left-0 right-0 z-50">
        <Footer />
      </div>
      
    </div>
  );
};

export default Layout;
